import Typography from "_components/atoms/typography";

import useStyles from "./styles";

const VideoBlockedView = () => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.videoEmptyView }>
			<div className = { classes.header }>
				<Typography
					title = "Stream not available"
				/>
			</div>
		</div>
	);
};

export default VideoBlockedView;